import Translations from '../Translations';
import React, {
    useEffect,
    useState,
} from 'react';
import {
    Modal,
    Button,
    Message,
    Icon,
} from 'semantic-ui-react';

const ModalNegativeBalanceWarning = (props) => {

    const {
        balanceAmount,
    } = props;

    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (balanceAmount < 0 && !open) {
            setOpen(true);
        }
    }, [balanceAmount]);

    return (
        <Modal
            open={open}
            dimmer="inverted"
        >
            <Modal.Content>
                <Message negative icon>
                    <Icon name='warning circle' />
                    <Message.Content><Translations text="selection.negative_balance_warning" backup={"This selection will result in a negative balance, which will require a deduction from your next payroll. Please change your selection if you do not wish to have a deduction."} /></Message.Content>
                </Message>
            </Modal.Content>
            <Modal.Actions>
                <Button
                    content={<Translations text="common.okay" backup={"Ok"} />}
                    primary
                    onClick={() => setOpen(false)}
                    fluid
                />
            </Modal.Actions>
        </Modal>
    );

};

export default ModalNegativeBalanceWarning;